(function() { module.exports = window["wp"]["data"]; }());